module.exports = __webpack_public_path__ + "static/media/logo-white.cb8e5e11.png";